/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.222.1-v202611032314-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqMetricsApiClass {
 
   constructor() {}

  /**
   * @summary Archive a metric
   * @param {string} id - The Seeq ID for the metric
  */
  public archiveMetric(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/metrics/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/metrics/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Create a metric that defines thresholds
  */
  public createThresholdMetric(
    body: models.ThresholdMetricInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/metrics/thresholds`;
    const urlTemplate = `${baseUrl}/metrics/thresholds`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ThresholdMetricOutputV1>;
  }

  /**
   * @summary Get metric
   * @param {string} id - The Seeq ID for the metric
  */
  public getMetric(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/metrics/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/metrics/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ThresholdMetricOutputV1>;
  }

  /**
   * @summary List metrics
   * @param {number} [offset=0] - The pagination offset, the index of the first metric that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of metrics that will be returned in this page of results
  */
  public getMetrics(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/metrics`;
    const urlTemplate = `${baseUrl}/metrics`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetMetricsOutputV1>;
  }

  /**
   * @summary Updates a metric that defines thresholds
   * @param {string} id - The Seeq ID for the metric
  */
  public putThresholdMetric(
    body: models.ThresholdMetricInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/metrics/thresholds/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/metrics/thresholds/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ThresholdMetricOutputV1>;
  }

}


export const sqMetricsApi = new sqMetricsApiClass();

export type sqMetricsApiEndpoints = {
  'archiveMetric': {
    method: 'delete';
    path: '/metrics/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'createThresholdMetric': {
    method: 'post';
    path: '/metrics/thresholds';
    response: models.ThresholdMetricOutputV1;
  };
  'getMetric': {
    method: 'get';
    path: '/metrics/${encodeURIComponent(String(id))}';
    response: models.ThresholdMetricOutputV1;
  };
  'getMetrics': {
    method: 'get';
    path: '/metrics';
    response: models.GetMetricsOutputV1;
  };
  'putThresholdMetric': {
    method: 'post';
    path: '/metrics/thresholds/${encodeURIComponent(String(id))}';
    response: models.ThresholdMetricOutputV1;
  };
};

type ApiArchiveMetricResponse = models.StatusMessageBase;
type ApiarchiveMetricMutationParams = Parameters<typeof sqMetricsApi.archiveMetric> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqMetricsApi.archiveMetric>;

export function useApiArchiveMetricMutation(
  options?: Omit<UseMutationOptions<ApiArchiveMetricResponse, AxiosError<SeeqErrorData>,
    ApiarchiveMetricMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveMetricResponse, AxiosError<SeeqErrorData>,
  ApiarchiveMetricMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveMetricMutationParams) =>
      sqMetricsApi.archiveMetric(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateThresholdMetricResponse = models.ThresholdMetricOutputV1;
type ApicreateThresholdMetricMutationParams = Parameters<typeof sqMetricsApi.createThresholdMetric> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqMetricsApi.createThresholdMetric>;
type ApicreateThresholdMetricMutationVariables = models.ThresholdMetricInputV1;

export function useApiCreateThresholdMetricMutation(
  options?: Omit<UseMutationOptions<ApiCreateThresholdMetricResponse, AxiosError<SeeqErrorData>,
    ApicreateThresholdMetricMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateThresholdMetricResponse, AxiosError<SeeqErrorData>,
  ApicreateThresholdMetricMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateThresholdMetricMutationVariables) =>
      sqMetricsApi.createThresholdMetric(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetMetricResponse = models.ThresholdMetricOutputV1;
export function GetMetricQueryKey(
  params: Parameters<typeof sqMetricsApi.getMetric>[0],
) {
  return ['sqMetricsApi', 'getMetric', params] as const;
}

export function useApiGetMetricQuery(
  params: Parameters<typeof sqMetricsApi.getMetric>[0],
  options?: Omit<UseQueryOptions<ApiGetMetricResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetMetricResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetMetricQueryKey(params),
    queryFn: () =>
      sqMetricsApi.getMetric(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetMetricsResponse = models.GetMetricsOutputV1;
export function GetMetricsQueryKey(
  params: Parameters<typeof sqMetricsApi.getMetrics>[0],
) {
  return ['sqMetricsApi', 'getMetrics', params] as const;
}

export function useApiGetMetricsQuery(
  params: Parameters<typeof sqMetricsApi.getMetrics>[0],
  options?: Omit<UseQueryOptions<ApiGetMetricsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetMetricsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetMetricsQueryKey(params),
    queryFn: () =>
      sqMetricsApi.getMetrics(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiPutThresholdMetricResponse = models.ThresholdMetricOutputV1;
type ApiputThresholdMetricMutationParams = Parameters<typeof sqMetricsApi.putThresholdMetric> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqMetricsApi.putThresholdMetric>;

export function useApiPutThresholdMetricMutation(
  options?: Omit<UseMutationOptions<ApiPutThresholdMetricResponse, AxiosError<SeeqErrorData>,
    ApiputThresholdMetricMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiPutThresholdMetricResponse, AxiosError<SeeqErrorData>,
  ApiputThresholdMetricMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiputThresholdMetricMutationParams) =>
      sqMetricsApi.putThresholdMetric(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
